import { useEffect } from "react";
import { useLocation } from "react-router";
import { useChatSupport } from "@hopper-b2b/self-serve";

export const CHAT_SUPPORT_QUERY_PARAM = "chat-support";
export const TRIP_ID_QUERY_PARAM = "tripId";

export const SupportModal = () => {
  const { generalSupportChat } = useChatSupport();
  const queryString = useLocation().search;

  useEffect(() => {
    const queryParams = new URLSearchParams(queryString);
    const isSupportEnabled = queryParams.has(CHAT_SUPPORT_QUERY_PARAM);

    if (isSupportEnabled) {
      generalSupportChat();
    }
  }, [generalSupportChat, queryString]);

  return null;
};
